import { useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { _CreditAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { MASK_DATE } from "../../../../theme/Component/BasicMultiSelecTable";
import { toast } from "react-toastify";

export const CuotaMes = () => {
    const instance = useDataBean(_CreditAccount);
    const [data, setData] = useState<any>('');
    const [lista, setLista] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const [fecha, setFecha] = useState<any>(_single.getCurrenDate());

    const loadData = () => {
        console.log(JSON.stringify(data));

        instance.instance.getCoutaCreditoByMonth(_single.getAccountID(), fecha, JSON.stringify(data)).then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }
    const loadDataNominadora = () => {
        console.log(JSON.stringify(data));

        instance.instance.executeUpdateNominadora(_single.getAccountID(),  JSON.stringify(data)).then(
            (resp: any) => {
                toast.success("Proceso terminado");
            }
        )
    }


    const head = [
        {title:'Credito',property:'CreditNumber',visible:true,mask:MASK_NUMBER},
        {title:'Identificacion',property:'Nit',visible:true,mask:MASK_NUMBER},
        {title:'Afiliado',property:'DeudorName',visible:true},
        {title:'Fecha Cuota',property:'FechaCuota',visible:true,mask:MASK_DATE},
        {title:'Cuota',property:'VrCuota',visible:true,mask:MASK_MONEY},
        {title:'Capital',property:'ValorCapital',visible:true,mask:MASK_MONEY},
        {title:'Interes',property:'InteresFijo',visible:true,mask:MASK_MONEY},
        {title:'Saldo',property:'SaldoCapital',visible:true,mask:MASK_MONEY},
           
    ]

    return (
        <div className="row">
            <div className="col-md-6">
                <InputDate label="Fecha Cierre" name="Fecha" value={fecha} setDate={setFecha} />
            </div>
            <div className="col-md-6">
                <ImportXLSX lodaData={setData} />
                <br />

            </div>
            <div className="col-md-12 mt-4">
                <BasicButton icon="" eventClick={loadDataNominadora}>Cargar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable head={head} body={lista} rowSet={setBean}></BasicTable>
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>
    )
}